/**
 * Toggle menu sidebar.
 *
 * @param { Object } event event
 */
function toggleMenuSidebar( event ) {
  event.preventDefault();
  document.querySelectorAll( '.menu-mobile-toggle' ).forEach( ( element ) => element.classList.toggle( 'is-active' ) );
  document.querySelector( 'body' ).classList.toggle( 'is-menu-sidebar' );
  document.documentElement.classList.toggle( 'cvle-scroll-lock' );
}
document.querySelectorAll( '.menu-mobile-toggle' ).forEach( ( element ) => element.addEventListener( 'click', toggleMenuSidebar ) );
